import {
  OPEN_DIALOG,
  CLOSE_DIALOG,
  FETCH_HIERARCHIES,
  FETCH_HIERARCHIES_START,
  FETCH_HIERARCHIES_SUCCESS,
  FETCH_HIERARCHIES_ERROR,
  FETCH_PROJECTS_SEARCH,
  FETCH_PROJECTS_SEARCH_START,
  FETCH_PROJECTS_SEARCH_SUCCESS,
  FETCH_PROJECTS_SEARCH_ERROR,
  POST_HIERARCHIES,
  POST_HIERARCHIES_START,
  POST_HIERARCHIES_SUCCESS,
  POST_HIERARCHIES_ERROR,
  UPDATE_PROJECTS_SEARCH,
  ADD_PROJECT,
  REMOVE_PROJECT,
  UPDATE_HIERARCHY_TYPE,
  UPDATE_PROJECTS,
  UPDATE_COMMENTS
} from './constants'

const openDialog = () => ({ type: OPEN_DIALOG })
const closeDialog = () => ({ type: CLOSE_DIALOG })

const addProject = (project, hierarchyType) => ({ type: ADD_PROJECT, project, hierarchyType })
const removeProject = (id) => ({ type: REMOVE_PROJECT, id })

const fetchHierarchies = (id) => ({ type: FETCH_HIERARCHIES, id })
const fetchHierarchiesStart = () => ({ type: FETCH_HIERARCHIES_START })
const fetchHierarchiesSuccess = () => ({ type: FETCH_HIERARCHIES_SUCCESS })
const fetchHierarchiesError = (error) => ({ type: FETCH_HIERARCHIES_ERROR, error })

const fetchProjectsSearch = (query) => ({ type: FETCH_PROJECTS_SEARCH, query })
const fetchProjectsSearchStart = () => ({ type: FETCH_PROJECTS_SEARCH_START })
const fetchProjectsSearchSuccess = () => ({ type: FETCH_PROJECTS_SEARCH_SUCCESS })
const fetchProjectsSearchError = (error) => ({ type: FETCH_PROJECTS_SEARCH_ERROR, error })
const updateProjectsSearch = (projects) => ({ type: UPDATE_PROJECTS_SEARCH, projects })

const updateHierarchyType = (value) => ({ type: UPDATE_HIERARCHY_TYPE, value })
const updateProjects = (projects) => ({ type: UPDATE_PROJECTS , projects })

const updateComments = (id, comments) => ({ type: UPDATE_COMMENTS, id, comments })

const postHierarchies = (payload) => ({ type: POST_HIERARCHIES, payload })
const postHierarchiesStart = () => ({ type: POST_HIERARCHIES_START })
const postHierarchiesSuccess = () => ({ type: POST_HIERARCHIES_SUCCESS })
const postHierarchiesError = (error) => ({ type: POST_HIERARCHIES_ERROR, error })

export {
  openDialog,
  closeDialog,
  addProject,
  removeProject,
  fetchHierarchies,
  fetchHierarchiesStart,
  fetchHierarchiesSuccess,
  fetchHierarchiesError,
  fetchProjectsSearch,
  fetchProjectsSearchStart,
  fetchProjectsSearchSuccess,
  fetchProjectsSearchError,
  updateProjectsSearch,
  updateHierarchyType,
  updateProjects,
  postHierarchies,
  postHierarchiesStart,
  postHierarchiesSuccess,
  postHierarchiesError,
  updateComments
}